import CardItem from "./CardItem";
import React from "react";
import PropTypes, {object} from "prop-types";
import Pagination from "@mui/material/Pagination";
import {MenuItem, Select} from "@mui/material";
import SoftBox from "../../../components/SoftBox";
const CardComponent = ({
                           data,
                           fetchArticles,
                           count,
                           size,
                           page,
                           loadingData,
                           handlePageChange,
                           handleRowsPerPageChange,
}) => {

    const handlePaginationSizeChange = (event) => {
        let newSize = parseInt(event.target.value, 10);
        handleRowsPerPageChange(newSize);
    };

    const handlePaginationPageChange = (event, newPage) => {
        const numberOfPages = Math.ceil((count ?? data.length) / size);
        let page = newPage <= numberOfPages ? newPage : 1;
        handlePageChange(page);
    };
    return(
        <React.Fragment>
            {data && data.map((element, index) => {
                return (
                    <SoftBox key={index} style={{paddingBottom: "10px"}}>
                        <CardItem
                            id={element.id}
                            title={element.title}
                            status={element.status}
                            author={element.authors}
                            publishedAt={element.published}
                            createdAt={element.createdAt}
                            referencesCount={element.references_count}
                            citationsCount={element.citations_count}
                            fetchArticles={fetchArticles}
                        />
                    </SoftBox>
                );
            })}

            {data.length > 0 ? (
                <SoftBox key={"pagination-card"}>
                    <SoftBox>
                        <SoftBox style={{display: "flex"}}>
                            <SoftBox style={{marginLeft: "auto"}}>
                                <Select
                                    id="rowsPerPage"
                                    fullWidth
                                    value={size}
                                    onChange={handlePaginationSizeChange}
                                    style={{
                                        width: "100%",
                                        padding: "10px 0px",
                                        border: "none",
                                        fontSize: "14px",
                                        boxSizing: "border-box",
                                        outline: "none",
                                    }}
                                    inputProps={{"aria-label": "Without label"}}
                                >
                                    <MenuItem key={"5"} value="5">5</MenuItem>
                                    <MenuItem key={"10"} value="10" selected={true}>10</MenuItem>
                                    <MenuItem key={"20"} value="20">20</MenuItem>
                                </Select>
                            </SoftBox>
                            <SoftBox>
                                <Pagination
                                    size="sm"
                                    color="primary"
                                    count={Math.ceil(count / size)}
                                    page={page}
                                    onChange={handlePaginationPageChange}
                                    showFirstButton
                                    showLastButton
                                    style={{marginLeft: "auto"}}
                                />
                            </SoftBox>
                        </SoftBox>
                    </SoftBox>
                </SoftBox>
            ) : loadingData ? (
                <p style={{textAlign: "center", padding: "50px"}}> Loading... </p> 
                ) :  <p style={{textAlign: "center", padding: "50px"}}> no results found!</p>
            }
        </React.Fragment>

    );
}

CardComponent.propTypes = {
    data: PropTypes.arrayOf(object),
    count: PropTypes.number,
    size: PropTypes.number,
    page: PropTypes.number,
    loadingData: PropTypes.bool,
    handlePageChange: PropTypes.func,
    handleRowsPerPageChange: PropTypes.func,
    };

export default CardComponent;